var React = require('react');

function Windows (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Vector","d":"M0.666748 0H20.5766V19.9009H0.666748V0ZM22.7572 0H42.6667V19.9009H22.7572V0ZM0.666748 22.0902H20.5766V42H0.666748V22.0902ZM22.7572 22.0902H42.6667V42H22.7572","fill":"#E0E7F6"}));
}

Windows.defaultProps = {"width":"43","height":"42","viewBox":"0 0 43 42","fill":"none"};

module.exports = Windows;

Windows.default = Windows;
